/**
 * Lazy load images
 *
 * @author Matt Haynes <mattgh9152@gmail.com>
 * @package Boohooman - Tracksuit testers
 */

import LazyLoad from 'vanilla-lazyload';

const lazyLoad = () => {
    const myLazyLoad = new LazyLoad();
    // After your content has changed...
    myLazyLoad.update();
};

export default lazyLoad;
